import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css"; 
import { LoadingProvider } from "./context/LoaderContext.jsx";
import { ChatContextProvider } from "./context/ChatContext.jsx";
import { ErrorBoundary } from "./components/ErrorBoundary";
 

ReactDOM.createRoot(document.getElementById("root")).render(
  <ErrorBoundary> 
    <LoadingProvider>
        <ChatContextProvider>
          <App />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />
        </ChatContextProvider>  
    </LoadingProvider>
  </ErrorBoundary>
);
